import type * as Maplibre from 'maplibre-gl'

let loading: Promise<typeof Maplibre> | null = null

// Loads maplibre-gl in the browser only: v6 is ESM-only and starts its worker from a URL,
// which with Vite has to come from the ?worker&url import and be set once with setWorkerUrl
export const loadMaplibre = () => {
  loading ??= Promise.all([
    import('maplibre-gl'),
    import('maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url')
  ]).then(([maplibre, worker]) => {
    maplibre.setWorkerUrl(worker.default)
    return maplibre
  })
  return loading
}
